/* =========================================================================
   SAMSARA — MOBILE-MENU.JS
   Clasa MobileMenu: open/close din stânga, focus trap, Escape, backdrop click,
   return focus la trigger. Ascultă `menu:open` dispatched de header.js.

   Link click → close drawer (browser aplică navigarea natural după).
   Dacă link-ul e către același URL ca pagina curentă → preventDefault + close.
   ========================================================================= */

(function () {
  'use strict';

  class MobileMenu {
    constructor(menu) {
      this.menu = menu;
      this.backdrop = document.querySelector('[data-mobile-menu-backdrop]');
      this.triggerButton = null;
      this.focusables = [];

      this.bindEvents();
    }

    bindEvents() {
      // Open (dispatched de header.js cu detail.trigger pentru focus return)
      document.addEventListener('menu:open', (e) => {
        this.triggerButton =
          (e.detail && e.detail.trigger) ||
          document.querySelector('[data-menu-trigger]');
        this.open();
      });

      // Close triggers (close button + backdrop + link clicks)
      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-mobile-menu-close]')) {
          e.preventDefault();
          this.close();
        }
      });

      if (this.backdrop) {
        this.backdrop.addEventListener('click', () => this.close());
      }

      // Link clicks: close drawer; navigare se face după animație prin browser
      this.menu.addEventListener('click', (e) => {
        const link = e.target.closest('a[data-mobile-menu-link]');
        if (!link) return;

        // Same URL: doar close, nu navigate
        if (link.href === window.location.href) {
          e.preventDefault();
          this.close();
          return;
        }
        // Altfel: close (browser navighează în background)
        this.close();
      });

      // Keyboard handling
      document.addEventListener('keydown', (e) => {
        if (!this.isOpen()) return;
        if (e.key === 'Escape') {
          this.close();
        } else if (e.key === 'Tab') {
          this.trapFocus(e);
        }
      });
    }

    isOpen() {
      return this.menu.getAttribute('aria-hidden') === 'false';
    }

    open() {
      if (this.isOpen()) return;
      this.menu.setAttribute('aria-hidden', 'false');
      if (this.backdrop) this.backdrop.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-scroll-locked');

      // Cache focusables acum (DOM stabil când open)
      this.focusables = this.getFocusableElements();

      // Focus primul element (close button) după animație
      window.setTimeout(() => {
        const closeBtn = this.menu.querySelector('[data-mobile-menu-close]');
        if (closeBtn) closeBtn.focus();
      }, 150);
    }

    close() {
      if (!this.isOpen()) return;
      this.menu.setAttribute('aria-hidden', 'true');
      if (this.backdrop) this.backdrop.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-scroll-locked');

      // Dispatch menu:closed pentru header.js (reset aria-expanded)
      document.dispatchEvent(new CustomEvent('menu:closed'));

      // Return focus la hamburger trigger
      if (this.triggerButton && typeof this.triggerButton.focus === 'function') {
        window.setTimeout(() => {
          this.triggerButton.focus();
        }, 100);
      }
    }

    trapFocus(e) {
      if (!this.focusables || this.focusables.length === 0) return;
      const first = this.focusables[0];
      const last = this.focusables[this.focusables.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    getFocusableElements() {
      const selector = [
        'a[href]',
        'button:not([disabled])',
        'input:not([disabled]):not([readonly])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[tabindex]:not([tabindex="-1"])',
      ].join(',');
      return Array.from(this.menu.querySelectorAll(selector)).filter(
        (el) => el.offsetParent !== null
      );
    }
  }

  function boot() {
    const menu = document.querySelector('[data-mobile-menu]');
    if (!menu) return;
    window.SamsaraMobileMenu = new MobileMenu(menu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
